import styled from 'styled-components';
import { media, Row } from '@simplywallst/ui-core';
interface ContainerProps {
  minHeight?: boolean;
}
export const Container = styled('header')<ContainerProps>`
  background-color: ${(props) => props.theme.color.noir};
  background-position: center;
  background-size: cover;
  min-height: 276px;
  position: relative;
  z-index: 1;
  padding: ${({ theme }) =>
    `${theme.x1spacePx + 4}px ${theme.x1spacePx}px ${theme.x1spacePx + 4}px ${
      theme.x2spacePx
    }px`};
  @media (min-width: 375px) {
    min-height: 248px;
  }
  ${media.mdUp`
    padding: ${({ theme }) => theme.x3spacePx}px ${({ theme }) =>
    theme.x4spacePx}px;
    min-height: 228px;
  `}
  ${media.lgUp`
    border-radius: 0 0 8px 8px;
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
    padding: ${({ theme }) => theme.x2spacePx}px ${({ theme }) =>
    theme.x4spacePx}px;
    min-height: 196px;
  `}
  ${media.xlUp`
    margin-left: 0;
  `}
  @media print {
    color: ${({ theme }) => theme.color.white} !important;
  }
`;

export const ContainerRow = styled(Row)`
  min-height: 252px;
  @media (min-width: 375px) {
    min-height: 224px;
  }
  ${media.mdUp`
    min-height: 180px;
  `}
  ${media.lgUp`
    min-height: 166px;
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => theme.typography.megaStrong}
  margin: 0;
  padding: 0;
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.x2spacePx - 2}px;
  span {
    ${({ theme }) => theme.typography.small}
    display: table;
    color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  }
  ${media.lgUp`
    ${({ theme }) => theme.typography.heroStrong}
  `}
`;

export const FloatingButtons = styled('div')`
  height: ${({ theme }) => theme.x4spacePx}px;
  z-index: 3;
  ${media.lgUp`
    width: 100%;
    text-align: right;
    margin-top: -30px;
  `};
`;

export const HeaderIcon = styled.div`
  margin: 3px 12px 0 0;
  float: left;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  ${media.lgUp`
    margin-top:4px;
  `}
`;
